module.exports = __webpack_public_path__ + "media/images/front/services/prototyping-edec71d6ebab479a200002d8b8bdce29.webp";